import React from 'react';
import PropTypes from 'prop-types';
import { Select } from '@mantine/core';

export default function DropdownSelectorField({ form, text, dataIndex, options }) {
  const fieldName = dataIndex === 'default' ? 'isDefault' : dataIndex;

  return (
    <Select
      label={text}
      data={options}
      value={form.values[fieldName] || 'false'}
      onChange={(value) => form.setFieldValue(fieldName, value)}
      size="md"
    />
  );
}

DropdownSelectorField.propTypes = {
  // eslint-disable-next-line react/forbid-prop-types
  form: PropTypes.object.isRequired,
  text: PropTypes.string,
  dataIndex: PropTypes.oneOfType([PropTypes.string, PropTypes.number]),
  options: PropTypes.arrayOf(PropTypes.shape({
    value: PropTypes.string.isRequired,
    label: PropTypes.string.isRequired,
  })).isRequired,
};
